export const SET_USER_PARAMETER = "SET_USER_PARAMETER";
export const SET_LINE_ID = "SET_LINE_ID";
export const SET_LOGIN_ERROR = "SET_LOGIN_ERROR";